import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios, { API } from "@/lib/apiClient";

export const TeamAccept = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("joining");
  const token = params.get("token");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }
    axios
      .post(`${API}/team/accept`, { token })
      .then(() => {
        setStatus("joined");
        setTimeout(() => window.location.assign("/team/dashboard"), 1200);
      })
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="team-accept-page">
      {status === "joining" && (
        <>
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-sovereign border-t-transparent" />
          <p className="text-slate-400">Joining your team instantly - no password needed...</p>
        </>
      )}
      {status === "joined" && <p className="font-heading text-xl font-bold text-truth-green" data-testid="team-accept-success">You're in! Redirecting to your dashboard...</p>}
      {status === "error" && <p className="text-sovereign" data-testid="team-accept-error">This invite link is invalid or has expired.</p>}
    </div>
  );
};
